module.exports = __webpack_public_path__ + "static/img/new.fbba50ec.webp";